import { Component, Input } from '@angular/core';

type RatingsColor = 'green' | 'red' | 'amber' | 'orange' | 'yellow' | 'high' | 'medium' | 'low' | '';

@Component({
  selector: 'risk-rating-indicator',
  template: `
    <div class="risk-rating-indicator" [style.padding-top]="topMargin" [style.width]="indicatorWidth">
      <div fxLayout="row">
        <div fxFlex fxLayout="row" fxLayoutAlign="center">
          <mat-icon *ngIf="activeBarColor === 'green' || activeBarColor === 'low'"> arrow_drop_down </mat-icon>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="center">
          <mat-icon
            *ngIf="
              activeBarColor === 'amber' ||
              activeBarColor === 'orange' ||
              activeBarColor === 'yellow' ||
              activeBarColor === 'medium'
            "
          >
            arrow_drop_down
          </mat-icon>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="center">
          <mat-icon *ngIf="activeBarColor === 'red' || activeBarColor === 'high'"> arrow_drop_down </mat-icon>
        </div>
      </div>
      <div class="indication-bar">
        <div fxFlex class="green-bg"></div>
        <div fxFlex class="amber-bg"></div>
        <div fxFlex class="red-bg"></div>
      </div>
    </div>
  `,
  styles: [
    `
      .risk-rating-indicator mat-icon {
        height: 22px;
        font-size: 31px;
      }
      .indication-bar > div {
        height: 6px;
      }
    `,
  ],
})
export class RiskRatingIndicationBarComponent {
  @Input() activeBarColor: RatingsColor = '';
  @Input() topMargin: string = '10px';
  @Input() indicatorWidth: string = '100%';
}
